import { render } from "./StudentRecharge.vue?vue&type=template&id=636d229a&scoped=true"
import script from "./StudentRecharge.vue?vue&type=script&lang=js"
export * from "./StudentRecharge.vue?vue&type=script&lang=js"

import "./StudentRecharge.vue?vue&type=style&index=0&id=636d229a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-636d229a"]])

export default __exports__